module.exports = __webpack_public_path__ + "front/img/p19.a7841066.png";